export function capitalizeFirstLetter(str) {
  if (!str) return ""
  str = str.toLowerCase()
  return str.charAt(0).toUpperCase() + str.slice(1)
}
export function formatPhoneNumberWithSpaces(number) {
  if (!number) return ""
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}
